import l from "./index474.js";
import { resolveComponent as f, createBlock as o, createCommentVNode as m, openBlock as n, resolveDynamicComponent as p, withCtx as s, createElementBlock as r, Fragment as a, renderList as g, createTextVNode as i, toDisplayString as d, mergeProps as y } from "vue";
import T from "./index231.js";
function k(e, _, C, $, x, B) {
  const c = f("ms-text", !0);
  return e.contentTag && e.contentTag.length ? (n(), o(p(e.tagType), {
    key: 0,
    "data-component": e.$options.name
  }, {
    default: s(() => [
      (n(!0), r(a, null, g(e.contentTag, (t, u) => (n(), r(a, null, [
        t.text ? (n(), r(a, { key: 0 }, [
          i(d(t.text), 1)
        ], 64)) : (n(), o(p(e.getComponent(t.type)), y({
          key: u,
          ref_for: !0
        }, e.mapProps(t)), {
          default: s(() => [
            t.children ? (n(), o(c, {
              key: 0,
              contentTag: t.children
            }, null, 8, ["contentTag"])) : m("", !0)
          ]),
          _: 2
        }, 1040))
      ], 64))), 256))
    ]),
    _: 1
  }, 8, ["data-component"])) : m("", !0);
}
const P = /* @__PURE__ */ T(l, [["render", k]]);
export {
  P as default
};
